export default __webpack_public_path__ + "assets/media/placeholder-channel.9e2920fe.svg";